import React from "react";
import classnames from "classnames";
import Rail from "web/react/components/rail/rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-designer-rail.css";

interface Item {
    title: string;
    image_url: string;
    image_alt: string;
    url: string;
}

interface DesignerRailItemProps {
    item: Item;
    type?: string;
}

const DESIGNER_CATEGORY = "DESIGNER_CATEGORY";

export function HomepageDesignerItem({ item, type }: DesignerRailItemProps): JSX.Element {
    const isDesignerCategory = type == DESIGNER_CATEGORY;
    return (
        <a
            className={classnames(styles.homepageDesignerItem, {
                [styles.homepageDesignerCategoryItem]: isDesignerCategory,
            })}
            href={item.url}
        >
            <LazyLoadImage
                className={classnames(styles.homepageDesignerImg, {
                    [styles.homepageDesignerCategoryImg]: isDesignerCategory,
                })}
                src={item.image_url}
                alt={item.image_alt}
            />
            <span
                className={classnames(styles.homepageDesignerLink, {
                    [styles.homepageDesignerCategoryLink]: isDesignerCategory,
                })}
            >
                {item.title}
            </span>
        </a>
    );
}

interface HomepageDesignerRailProps {
    items: Item[];
    type?: string;
    analyticsLabel?: string;
}

export function HomepageDesignerRail({
    items,
    type,
    analyticsLabel = "homepage_designer_rail",
}: HomepageDesignerRailProps): JSX.Element {
    const buttonStyle = classnames(styles.scrollButton, {
        [styles.scrollCategory]: type === DESIGNER_CATEGORY,
    });
    const leftButtonStyle = classnames(buttonStyle, styles.left);
    const rightButtonStyle = classnames(buttonStyle, styles.right);

    return (
        <Rail
            className={styles.homepageDesignerRail}
            analyticsLabel={analyticsLabel}
            title={""}
            leftButtonStyle={leftButtonStyle}
            rightButtonStyle={rightButtonStyle}
            buttonIcon={"square-chevron"}
        >
            {items.map((item) => {
                return <HomepageDesignerItem key={item.url} item={item} type={type} />;
            })}
        </Rail>
    );
}

export default HomepageDesignerRail;
